'use client';
 
import Content_Roting from './Content_Roting';
import BtnSendFormModal from '../BtnSendFormModal';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import FormLoginModal from '../FormLoginModal';
import FormTurnModal from '../FormTurnModal';
import useInputOnchnage from '@/hook/useInputOnchnage';
import { TypeTurnSelection } from '../types/AdmissionType';
import { useEffect, useState } from 'react';
import { setFormModal } from '@/lib/RTK/features/AdmissionSlice';
import { cn } from '@/lib/utils';
import { FaSpinner } from 'react-icons/fa';

export default function TurnSelection(props: TypeTurnSelection) {
    const {
        allTurns,
        doctor,
        months,
        firstTurn: firstTunr,
        timeTurnfirst,
        docname,
        per_visit,
        matab_plus,
        matab_plus_id,
        coordination,
        setShowTurnModal,
    } = props;

    const dispatch = useAppDispatch();
    const [selectedValue, handleChange] = useInputOnchnage(
        matab_plus_id ? 'second' : 'first',
    );
    const [enableSubmit, setSubmitEnable] = useState(false);
    const psistionModal = useAppSelector((state) => state.admission.position);

    function handleResetPosition() {
        dispatch(setFormModal(''));
    }

    function changeTurnToFirst() {
        handleChange('first');
    }

    useEffect(() => {
        changeTurnToFirst();
        handleResetPosition();
    }, []);

    useEffect(() => {
        if (matab_plus) {
            setSubmitEnable(false);
            return;
        }
        if (selectedValue === 'first') {
            setSubmitEnable(true);
        } else {
            process.nextTick(() => {
                window.scrollTo(0, 200);
            });
        }
    }, [selectedValue]);

    return (
        <div className='flex-col gap-2 flex'>
            <div className="border_box p-2 sm:!p-6">
                {!matab_plus && (
                    <>
                        <h3 className="font-bold px-2 sm:!px-0 text-base">
                            انتخاب زمان نوبت:
                        </h3>
                        <div className="flex_col gap-3 mt-3">
                            <div className='gap-2'>
                                <div
                                    className="flex_center gap-2 w-full"
                                    onClick={changeTurnToFirst}
                                >
                                    <input
                                        type="radio"
                                        className="flex-grow min-w-[5%] max-w-[5%] checked_input_style"
                                        value="first"
                                        checked={selectedValue === 'first'}
                                        onChange={() => {}}
                                    />
                                    <label
                                        className="flex-grow max-w-[90%] text-sm md:text-base"
                                        htmlFor="first"
                                    >
                                        اولین زمان آزاد: {firstTunr}
                                    </label>
                                </div>
                            </div>
                            {months ? (
                                <div
                                    className="flex_center gap-2 w-full"
                                    onClick={() => handleChange('second')}
                                >
                                    <input
                                        type="radio"
                                        className="flex-grow min-w-[5%] max-w-[5%] checked_input_style"
                                        value="second"
                                        checked={selectedValue === 'second'}
                                        disabled={months.length === 0}
                                        onChange={() => {}}
                                    />
                                    <label
                                        className={cn(
                                            months.length === 0
                                                ? 'line-through'
                                                : '',
                                            'flex-grow max-w-[90%] text-sm md:text-base',
                                        )}
                                        htmlFor="second"
                                    >
                                        زمان دیگر
                                    </label>
                                </div>
                            ) : (
                                <>
                                        <FaSpinner className='text-xl animate-spin' />
                                    <label>زمان دیگر</label>
                                </>
                            )}
                        </div>
                    </>
                )}
                <article className="my-4">
                    {(selectedValue === 'second' || matab_plus) && (
                        <Content_Roting
                            setSubmitEnable={setSubmitEnable}
                            doctor={doctor}
                            allTurns={allTurns}
                            dates={months}
                            matab_plus_id={matab_plus_id?.id}
                            timeTurnfirst={undefined}
                        />
                    )}
                </article>
                <div className='justify-end'>
                    {psistionModal === '' && (
                        <BtnSendFormModal
                            per_visit={per_visit}
                            docname={docname}
                            handleResetPosition={handleResetPosition}
                            enableSubmit={enableSubmit}
                            coordination={coordination}
                            setShowTurnModal={setShowTurnModal}
                        />
                    )}

                    {psistionModal === 'formlogin' && (
                        <FormLoginModal
                            docname={docname}
                            handleResetPosition={handleResetPosition}
                            enableSubmit={enableSubmit}
                        />
                    )}
                    {psistionModal === 'formturn' && (
                        <FormTurnModal
                            ids={{
                                clinicid: doctor.clinic,
                                docid: doctor.docid,
                            }}
                            docname={docname}
                            clinic={doctor.clinic}
                            docid={doctor.docid}
                            timeTurnfirst={timeTurnfirst}
                            handleResetPosition={handleResetPosition}
                            enableSubmit={enableSubmit}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
